import React from 'react';
import { Page, Text, View, Image, Document, StyleSheet, PDFViewer} from '@react-pdf/renderer';
import logonfh from '../../../assets/images/logonfh.png'

const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      flexWrap:"wrap",
      backgroundColor: '#E4E4E4',
      paddingTop:10,
      paddingBottom:10,
      paddingLeft:5
    },
    image: {
        width: '100%',
        marginBottom:5
    },
    imageQr: {
        width: "90px",
        marginTop:5
    },
    sectionQr:{
        display:"flex",
        flexDirection:"row",
        justifyContent:"flex-start",
    },
    section: {
      display:"flex",
      flexDirection:"column",
      marginTop: 5,
      marginBottom:5,
      marginRight:5,
      marginLeft:5,
      padding: 4,
      width:"4in",
      height:"2in",
      borderRadius:5,
      backgroundColor:"#eaeaea"
    },
    infoProduct:{
        width:"100%",
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"flex-start",
        marginLeft:10
    },  
    titleProduct:{
        width:"150px",
        fontSize:16
    },
    medidaProduct:{
        fontSize:12,
        marginTop:5
    },
    precioProduct:{
        fontSize:22,
        fontWeight:600
    },
    containerName:{
        width:"100%"
    }

  });
const GeneratePDF = ({productos}) => {
    if(!productos && productos.length<0){
        return null
    }
    else{
        return (
            <Document>
                <Page size="letter" style={styles.page} wrap>
                    {productos && productos.length>0 &&
                        productos.map((item)=>
                            <View  style={styles.section} key={item.id}>
                                <View style={styles.image}>
                                     <Image src={logonfh}/>
                                </View>
                                <View  style={styles.sectionQr}>
                                    <View style={styles.imageQr}>                 
                                        {/* <Image src={`http://api.qrserver.com/v1/create-qr-code/?data=https://nfhpanel.web.app/productos/${item.id}&size=50x50`}/> */}
                                        <Image src={item.code_qr}/>
                                        {/* <Image src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=http://192.168.1.153:3000/productos/${item.id}`}/> */}                                     
                                    </View>
                                    <View style={styles.infoProduct}>
                                        <View style={styles.containerName}>
                                            <Text style={styles.titleProduct}>{item.Nombre}</Text>  
                                        </View>
                                                       
                                        <Text style={styles.medidaProduct}>Id material: {item.IdMaterial}</Text>
                                    </View>
                                </View>
                            </View>
                        )
                    }
                   
                  
                </Page>
            </Document>
);
    }
   
};

export default GeneratePDF;